import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { AppliedJobModel } from 'src/app/models/AppliedJobModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { AppliedJobConstant } from 'src/app/constants/label-constants';
import { jobViewComponent } from '../Job-view/Job-view.component';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { Location } from '@angular/common';

@Component({
  selector: 'app-job-type',
  templateUrl: './job-type.component.html',
  styleUrls: ['./job-type.component.scss'],
})

export class JobTypeComponent {
  AppliedJobList: any = [];
  enterSearch: string = '';
  searchClose:boolean= false;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  showData: boolean = false;
  exportButton: boolean = true;
  JObId: number = 0;
  Title:string="";
  errorMessage:any=[];
  NoRecordFound:any=[];
  AppliedJobConstant:any=[];
  displayedColumns: string[] = ['rowNumber', 'fullName', 'mobileNo','emailId', 'noticePeriod', 'totalExperience','resume','action'];
  pageSizeOptions: number[] = [5, 10, 25, 100];
  dataSource : MatTableDataSource<AppliedJobModel>= new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  async ngOnInit(): Promise<void> 
  {
    await this.getAppliedJobList();
    this.AppliedJobConstant = AppliedJobConstant;
    this.errorMessage=commonErrorMessage;
    this.NoRecordFound = NoRecordFound;
  }

  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal,
    private toster: ToastrService,
    private route: ActivatedRoute,
    private _location: Location
  ) { }

  backButtoEvent() {
    this._location.back();
  }
  
  clearSearch()
  {
    this.Title='';
    this.getAppliedJobList();
  }

  async getAppliedJobList() {
    this.route.params.subscribe((params) => {  
      if (params['id'] !== undefined) {
        var decrypted = params['id'] ? params['id'] : '';
        this.JObId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
        var decryptedtitle = params['title'] ? params['title'] : '';
        this.Title = (this.EncrDecr.get('123456$#@$^@1ERF', decryptedtitle));
      }
    })
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection,
      jobId: this.JObId
    }

    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.job.AppliedJobList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.AppliedJobList = response.data
          this.dataSource.data = this.AppliedJobList;
          if (this.AppliedJobList.length > 0) {
            TotalRecords = this.AppliedJobList[0].totalRecords;
            this.totalRows = TotalRecords;
            this.exportButton = true;
          }
          else{
            this.exportButton = false;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
          this.spinner.hide();
        }
        else{
          this.spinner.hide();
          this.exportButton = false;
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.exportButton = false;
        this.toster.error(error.message);
      }
    });
  }

  AppliedJobDetail(ApplyJobId:number) {
    const modalRef = this.modalService.open(jobViewComponent , { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.JobApplyId =ApplyJobId;
    modalRef.result.then((result) => {
      
    }).catch((error) => {
    });
  }

  DownloadResume(url:string)
  {
      this.commonService.doDownload(url,true).subscribe(response => {
        const a = document.createElement('a');
        let blob: Blob = response.body!;
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download =this.extractFileName(url); // Desired file name for the downloaded image  
        // Programmatically click the anchor element to initiate the download
        document.body.appendChild(a);
        a.click();  
        // Clean up after download
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
      });
  }

  extractFileName(url: string | undefined): string {
    if (!url) {
      // throw new Error('URL is undefined.');
      return '';
    }
    const parsedUrl = new URL(url);
    return parsedUrl.pathname.split('/').pop() || ''; // Return empty string if filename is not found
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAppliedJobList();
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getAppliedJobList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.getAppliedJobList();
      this.searchClose = false;
    }
    else{
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.enterSearch = event.target.value.trim();
      this.getAppliedJobList();
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getAppliedJobList();
    this.searchClose = false;
  }

  refresh(){
    this.enterSearch = '';
    this.searchClose = false;
    this.getAppliedJobList();
  }

  public ExportToExcel(): void {
    const objData = {
      filter: this.enterSearch,
      title: this.Title,
      jobId: this.JObId
    }
    const apiUrl = this.apiUrl.apiUrl.job.ExportToExcel;
    this.spinner.show();
    this.commonService.doDownloadCSVPost(apiUrl,objData).pipe().subscribe(response => {
      let filename = response.headers.get('content-disposition')
        ?.split(';')[1].split('=')[1];
      let blob: Blob = response.body!;
      let a = document.createElement('a');
      a.download = this.Title +" "+ filename!;
      a.href = window.URL.createObjectURL(blob);
      a.click();
      this.spinner.hide();
    })
  }

  downloadPdf() {
    this.spinner.show();
    const objData = {
      filter: this.enterSearch,
      title: this.Title,
      jobId: this.JObId
    }
    const url = this.apiUrl.apiUrl.job.ExportPDF  ;
    this.commonService.DownloadPDFFilePost(url, objData).subscribe(
      (buffer: Blob) => {
        if (buffer && buffer.size > 0) {
          const blob = new Blob([buffer], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = `${this.Title} Applied Job.pdf`;
          a.click();
          URL.revokeObjectURL(blobUrl);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.toster.error(CommonConstant.FileNotFound);
        }
      },
      (error) => {
        console.error('Error:', error);
        this.spinner.hide();
      }
    ); 
  }
}


